import { StationsSelect } from '@app/components/stations/StationsSelect';
import { useStationsWithAudit } from '../hooks/useStationsWithAudit';

export const AuditStationsSelect = ({
  name = 'stations',
  maxSelected,
  multiple,
}: {
  name?: string;
  maxSelected?: number;
  multiple?: boolean;
}) => {
  return (
    <StationsSelect
      name={name}
      stations={useStationsWithAudit()}
      maxSelected={maxSelected}
      multiple={multiple}
    />
  );
};
